import { gql } from "@apollo/client";

export const DELETE_TEST_REPOS_MUTATION = gql`
  mutation deleteTestRepos {
    deleteTestRepos
  }
`;
